module.exports = __webpack_public_path__ + "img/icloud.9d34a754.png";